export default "__VITE_ASSET__6914e9f4__"